<template>
  <div v-if="closeReasons" class="close-reason">
    <CommonBanner
      class="close-reason__title"
      :tagline="$t`Укажите причину закрытия`"
      type="neutral"
    />
    <RadioButtons v-model="selectedReason" :items="closeReasons" divided />
    <ExpandTransition duration="250">
      <div v-if="isCustomReason" class="reason-input">
        <Textarea
          v-model="customReason"
          :maxLength="inputMaxLength"
          :persistent="showInputError"
          :rules="[(v) => !!v || $t`Введите причину закрытия`]"
          :label="$t`Введите причину закрытия`"
        />
      </div>
    </ExpandTransition>
    <CommonButton v-show="isButtonVisible" spaced @click="proceed">
      {{ $t`Продолжить` }}
    </CommonButton>
  </div>
</template>

<script>
import { getCloseReasons, getDetailsOnClose } from "@/api/close";
import CommonBanner from "@/components/shared/banner/CommonBanner.vue";
import CommonButton from "@/components/shared/button/CommonButton.vue";
import RadioButtons from "@/components/shared/radio/RadioButtons.vue";
import Textarea from "@/components/shared/input/Textarea.vue";
import ExpandTransition from "@/components/shared/transitions/ExpandTransition.vue";

const MINIMAL_RED_LIMIT = 50000;

export default {
  components: {
    CommonButton,
    CommonBanner,
    RadioButtons,
    ExpandTransition,
    Textarea,
  },
  data() {
    return {
      selectedReason: null,
      closeReasons: null,
      isMinimalLimit: false,
      customReason: "",
      inputMaxLength: 100,
      showInputError: false,
      isPlannedForClosing: false,
    };
  },
  async created() {
    const closeReasons = await getCloseReasons();
    this.closeReasons =
      closeReasons?.reduce((acc, r) => {
        acc[r.name] = { ...r };
        return acc;
      }, {}) || [];
    this.$logAnalyticEvent("mybank_red_close_purpose", {
      page_path: "/bank/closered/reason",
    });
    const { red_products } = await this.$store.dispatch("bundle/fetchBundle");
    this.isPlannedForClosing = red_products[0].is_planned_for_closing;
    this.isMinimalLimit = red_products[0].original_amount <= MINIMAL_RED_LIMIT;
  },
  computed: {
    variationId() {
      const testUserGroup = this.$cookie.getCookie("test.user.group");
      if (testUserGroup <= 40) {
        return "neutral";
      }
      if (testUserGroup > 40 && testUserGroup < 71) {
        return "control";
      }
      return "test";
    },
    isButtonVisible() {
      return this.selectedReason !== null;
    },
    isCustomReason() {
      return (
        this.selectedReason &&
        this.closeReasons[this.selectedReason].name === "another"
      );
    },
  },
  methods: {
    async proceed() {
      const reason = this.closeReasons[this.selectedReason];
      if (
        reason.name === "lower_limit" &&
        !this.isMinimalLimit &&
        !this.isPlannedForClosing &&
        reason.is_test
      ) {
        this.$router.push({
          path: "/bank/red/reduce-limit",
          query: { src: "close" },
        });
        return;
      }

      if (
        reason.name === "another" &&
        (!this.customReason || this.customReason.length > this.inputMaxLength)
      ) {
        this.showInputError = true;
        return;
      }

      const closeDetails = await getDetailsOnClose();
      if (closeDetails?.balance > 0 && closeDetails?.products.length !== 0) {
        this.$router.push("/bank/red/close/transfer");
        return;
      }

      const purpose = this.isCustomReason
        ? this.customReason
        : this.closeReasons[this.selectedReason].text;
      this.$router.push({
        path: "/bank/red/close",
        query: {
          purpose,
        },
      });
    },
  },
  watch: {
    selectedReason(val) {
      const reason = this.closeReasons[val];
      this.$logAnalyticEvent("mybank_red_close_purpose_selected", {
        page_path: "/bank/closered/reason",
        purpose: reason.text,
      });
    },
    customReason() {
      if (!this.showInputError) this.showInputError = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.backdrop {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &__img {
    width: 200px;
    height: 120px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__title {
    font-family: Roboto-Black;
    color: #4a4a4a;
    font-size: 24px;
    line-height: 28px;
    padding: 0 15px 15px;
  }

  &__footer {
    padding: 15px;

    &_reject {
      margin-top: 15px;
    }
  }
}

.reason-input {
  overflow: hidden;

  .textarea-wrapper {
    margin-top: 10px;
  }
}

.close-reason {
  font-family: Roboto-Regular;

  &__img {
    width: 200px;
    height: 120px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__title {
    font-family: Roboto-Black;
    color: #4a4a4a;
    font-size: 24px;
    line-height: 28px;
  }

  &__footer {
    padding: 15px;

    &_reject {
      margin-top: 15px;
    }
  }
}

.close-reason {
  font-family: Roboto-Regular;

  &__title {
    border-bottom: 1px solid #f0f0f0;
  }
}
</style>
